// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__hGvNr","card":"Card_card__9hfB7","info":"Card_info__Enwmd"};